const KNOWN_ROOT_SEGMENTS = new Set([
  "teacher-hub",
  "classes-manager",
  "schedule-manager",
  "automations-manager",
  "automation-timeline",
  "design-system",
  "automated-routine-builder",
  "events-manager",
  "settings",
  "admin-panel",
  "school-dashboard",
  "faq",
  "pricing",
  "contact",
  "debug",
  "share",
  "admin",
  "school",
  "purchase-order",
  "account",
  "auth",
  "blog",
  "tools",
  "form",
  "countdown-form",
  "countdown-form-v2",
  "reminder-form",
  "announcement-form",
  "music-form",
  "auto-status",
  "fullscreen",
  "export",
  "print",
  "sound-meter-history",
  "panel",
  "whats-new",
  "referral-program",
  "privacy",
  "trust",
  "why-lesson-launchpad",
  "show",
  "show-pricing",
  "metronome",
  "tone-generator",
  "tuner",
  "music-tools",
  "out-of-tune",
  "classroom-timer",
  "countdown-timer",
  "random-student-picker",
  "what-is-classroom-automation",
  "classroomscreen-alternative",
  "for-administrators",
  "quote",
  "spotify-callback",
  "canva-callback",
  "canva-return",
  "gmail-callback",
  "referral-program-terms",
  "r",
  "embed",
  "demo",
  "dev",
  "compare",
  "thing",
]);

export function normalizeSentryRoutePathname(pathname) {
  if (!pathname) {
    return "/";
  }

  let path = String(pathname).replace(/[?#].*$/, "");
  if (!path.startsWith("/")) {
    path = `/${path}`;
  }

  path = path.replace(/^\/share\/[^/]+\/[^/]+$/, "/share/:shareCode/:classId");
  path = path.replace(/^\/content-manager\/[^/]+$/, "/content-manager/:classId");
  path = path.replace(/^\/calendar\/[^/]+$/, "/calendar/:classId");
  path = path.replace(/^\/blog\/[^/]+$/, "/blog/:blogId");
  path = path.replace(/^\/school\/[^/]+$/, "/school/:schoolId");
  path = path.replace(/^\/demo\/[^/]+$/, "/demo/:scenario");
  path = path.replace(/^\/r\/[^/]+$/, "/r/:referralCode");
  path = path.replace(/^\/purchase-order\/confirmation\/[^/]+$/, "/purchase-order/confirmation/:requestId");
  path = path.replace(/^\/purchase-order\/upload\/[^/]+$/, "/purchase-order/upload/:requestId");
  path = path.replace(/^\/admin\/seo\/articles\/[^/]+$/, "/admin/seo/articles/:articleId");
  path = path.replace(/^\/dev\/scenario-login\/[^/]+$/, "/dev/scenario-login/:scenarioId");
  path = path.replace(/^\/dev\/scenario\/[^/]+$/, "/dev/scenario/:scenarioId");

  path = path.replace(/\/id[a-zA-Z0-9]+/g, "/:classId");

  const singleSegmentMatch = path.match(/^\/([^/]+)$/);
  if (singleSegmentMatch && !KNOWN_ROOT_SEGMENTS.has(singleSegmentMatch[1])) {
    path = "/:classId";
  }

  return path;
}
